import { hasFeature } from '@/mixins/hasFeature.js';
import { isInoperableCategory } from '@/Pages/WorkOrders/Modals/catsaExtras.js';

const isInoperableScope = (caseCategory, assetOperability, catsaExtrasConfig) =>
    typeof caseCategory === 'string' && caseCategory !== ''
        ? isInoperableCategory(caseCategory, catsaExtrasConfig)
        : assetOperability === 'inoperable';

export const isImpactAssessmentApplicable = (assetCritical, caseCategory, assetOperability, workOrderType, config, catsaExtrasConfig) => {
    if (!hasFeature('work_order_impact_assessment')) return false;
    if (!(config?.work_order_types ?? []).includes(workOrderType)) return false;
    if (!isInoperableScope(caseCategory, assetOperability, catsaExtrasConfig)) return false;
    return assetCritical === true;
};

export const isImpactAssessmentComplete = (assessment) => {
    const v = assessment ?? {};
    if (typeof v.outage_impact_within_hour !== 'boolean') return false;
    if (v.outage_impact_within_hour === true && typeof v.wtsl_target_exceeded !== 'boolean') return false;
    return true;
};

// Mirrors ImpactAssessmentClassifier::classify on the backend; used for live badge display.
export const impactAssessmentLevel = (assessment) => {
    const v = assessment ?? {};
    if (v.outage_impact_within_hour === false) return 3;
    if (v.outage_impact_within_hour === true && v.wtsl_target_exceeded === true) return 1;
    if (v.outage_impact_within_hour === true && v.wtsl_target_exceeded === false) return 2;
    return null;
};
